/* eslint-disable react/no-danger */
import _ from 'lodash';
import React, { useState } from 'react';
import { Button, Switch, Text } from 'src/@vymo/ui/atoms';
import { TabLayout } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { useAppSelector } from 'src/store/hooks';
import IndividualRankingCard from '../components/myRankings';
import {
  getIndividualRankings,
  getRankings,
  getRankingsMeta,
  getRankingsTableInfo,
} from '../selector';
import RankingChart from './rankingChart';
import RankingList from './rankingList';
import styles from '../index.module.scss';

function LeaderboardWidget({
  leaderboards,
  activeLeaderboard,
  setActiveLeaderboard,
}) {
  const rankings = useAppSelector(getRankings);
  const rankingsTableInfo = useAppSelector(getRankingsTableInfo);

  const rankingsMeta = useAppSelector(getRankingsMeta);
  const individualRanking = useAppSelector(getIndividualRankings);
  const [rankingView, setRankingView] = useState<string>('chart');
  return (
    <Widget
      title="Leaderboard"
      content={
        <div className={styles.leaderboard}>
          {Boolean(leaderboards?.length) && (
            <TabLayout
              items={leaderboards?.map((item) => ({
                label: item.name || '',
                key: item.code || '',
              }))}
              defaultKey={activeLeaderboard}
              onChange={(key) => setActiveLeaderboard(key)}
            />
          )}
          {!_.isEmpty(individualRanking) && (
            <IndividualRankingCard individualRanking={individualRanking} />
          )}
          {!_.isEmpty(rankings) &&
            (rankingView === 'list' ? (
              <RankingList
                title={rankingsTableInfo.title}
                rankings={[...(rankings || [])]
                  .sort((a, b) => b.points - a.points)
                  .slice(0, 3)}
              />
            ) : (
              <RankingChart
                rankings={[...(rankings || [])]
                  .sort((a, b) => b.points - a.points)
                  .slice(0, 3)}
              />
            ))}
        </div>
      }
      description={
        <span dangerouslySetInnerHTML={{ __html: rankingsMeta?.lastUpdated }} />
      }
      actions={
        <div>
          <div className={styles.leaderboard__chartToggle}>
            <Text type="sublabel">Chart view</Text>
            <Switch
              value={rankingView === 'chart'}
              onChange={(checked) => setRankingView(checked ? 'chart' : 'list')}
            />
          </div>

          <Button
            type="outlined"
            onClick={() => {
              window.location.hash = '/performance/leaderboard';
            }}
          >
            View All
          </Button>
        </div>
      }
      classNames={styles.leaderboard__widget}
    />
  );
}

export default LeaderboardWidget;
